(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector(".popular-products-slider");
    if (!sliderEl) return;

    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 6);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );

    const nextBtn = section.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = section.querySelector(
      ".heading-group__navigation-button-prev"
    );

    const paginationElement = section.querySelector(
      ".heading-group__pagination"
    );
    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: slidesPerViewMobile,
      spaceBetween: 4,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationElement,
        type: "fraction",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
          slidesPerGroup: slidesPerView576,
        },
        990: {
          slidesPerView: slidesPerView990,
          slidesPerGroup: slidesPerView990,
        },
        1100: {
          slidesPerView: slidesPerView1100,
          slidesPerGroup: slidesPerView1100,
        },
        1360: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
        },
      },
    };

    const swiperInstance = new Swiper(sliderEl, sliderSettings);

    const productCards = sliderEl.querySelectorAll(".product-card-js");
    productCards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        swiperInstance.allowTouchMove = false;
        swiperInstance.mousewheel.disable();
      });
      card.addEventListener("mouseleave", () => {
        swiperInstance.allowTouchMove = true;
        swiperInstance.mousewheel.enable();
      });
    });
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(".popular-products-slider");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();
    sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
    sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.removeAttribute("style");
    });
  };

  const initSectionLayout = (section) => {
    if (!section || !section?.classList.contains("popular-products-section")) {
      return;
    }

    const box = section.querySelector(".popular-products");
    if (!box) return;

    const layout = box.dataset.layout || "grid";
    if (layout === "slider") {
      initSlider(box);
    } else {
      destroySlider(box);
    }
  };

  initSectionLayout(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSectionLayout(event.target);
  });
})();
